import React, { Component } from 'react';

import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import ReactToolTip from 'react-tooltip';

import CalendarHeader from '../calendar/components/CalendarHeader';
import DesignerHeader from '../designer/components/DesignerHeader';
import CalendarTitle from '../calendar/components/CalendarTitle';
import AppStatus from '../common/AppStatus';
import Notifications from '../../v5/notifications/components/Notifications';
import RTooltips from '../calendar/components/Tooltips';
import LoggedInUserAvatar from './LoggedInUserAvatar';
import UpgradeButton from './UpgradeButton';
import Console from '../../lib/debug';
import MessagingButton from '../../v5/messaging/components/MessagingButton';

export default class CalendarNavBar extends Component {
    componentDidMount() {
        const navBar = document.getElementById('loading-nav-bar');
        navBar && navBar.classList.remove('loading-nav-bar');
    }
    render() {
        Console.render('CalendarNavBar');
        return (
            <AppBar position="fixed" className="nav-bar calendar-nav-bar">
                <Toolbar>
                    <CalendarTitle />
                    <DesignerHeader {...this.props} />
                    <Typography
                        variant="title"
                        color="inherit"
                        className="flex"
                    />
                    <div className="right-container">
                        <AppStatus />
                        <UpgradeButton />
                        <MessagingButton />
                        <Notifications />
                        <LoggedInUserAvatar />
                    </div>
                </Toolbar>
                <CalendarHeader />
                <RTooltips />
                <ReactToolTip id="app-tooltip" />
            </AppBar>
        );
    }
}
